import {Component} from "@angular/core";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {ProjectService} from "../project/project.service";
import {SearchHelpers} from "../helpers/search-helper";
import {
  DartOfferModel, PurchaseOrderModel,
} from "./purchase-order.model";

export interface PurchaseOrderDartOffersSelectDialogModel {
  projectId: string;
  purchaseOrder: PurchaseOrderModel;
  preSelectedDartOffers: DartOfferModel[];
}

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 5;

@Component({
  templateUrl: "./purchase-orders-dart-offers-dialog.template.pug",
  providers: [
    ProjectService,
  ],
})

export class PurchaseOrdersDartOffersSelectDialogComponent
  extends DialogComponent<PurchaseOrderDartOffersSelectDialogModel, any>
  implements PurchaseOrderDartOffersSelectDialogModel {
  error: Error;
  projectId: string;
  purchaseOrder: PurchaseOrderModel;
  preSelectedDartOffers = [];

  dartOffers = [];
  dartOffersFiltered = [];
  dartOffersDisplay = [];

  loading: boolean = false;
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  totalCount: number = 0;
  searchText: string = "";

  constructor(
    public dialogService: DialogService,
    private projectService: ProjectService,
  ) {
    super(dialogService);
  }

  async ready() {
    await this.loadDartOffersList();
    this.loadDartOffersToDisplay();
  }

  async loadDartOffersList() {
    this.loading = true;
    this.dartOffers = await this.projectService.getDartOffers(this.projectId);
    this.dartOffers = this.dartOffers.map(dartOffer => ({
      ...dartOffer,
      selected: this.purchaseOrder.dartOffers.findIndex(psdo =>
        (psdo.offerNumber !== "") && (psdo.offerNumber === dartOffer.offerNumber)) > -1,
      disabled:
        this.purchaseOrder.dartOffers.findIndex(psdo =>
          (psdo.offerNumber !== "") && (psdo.offerNumber === dartOffer.offerNumber)) < 0 &&
        this.preSelectedDartOffers.findIndex(psdo =>
          (psdo.offerNumber !== "") && psdo.offerNumber === dartOffer.offerNumber) > -1,
    }));
    this.loading = false;
  }

  private loadDartOffersToDisplay() {
    if (this.projectId && this.dartOffers && this.dartOffers.length > 0) {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;

      this.totalCount = this.dartOffers.length;
      this.dartOffersFiltered = this.dartOffers.filter((dartOffer) => {
        if (!dartOffer || !dartOffer.offerNumber) return false;

        if (this.searchText) {
          const values = [
            dartOffer.offerNumber,
            dartOffer.offerDescription,
          ];

          const searchFailures = SearchHelpers.tokenizeString(this.searchText) // split on spaces but consider "" and ''
            .map(v => SearchHelpers.stripQuotes(v)) // strip quotes on ends if present
            .map(v => SearchHelpers.cleanParam(v)) // sanitize to create regexp
            .map(v => new RegExp(v, "i")) // create regexp
            .map(re => values.some(v => re.test(v))) // test regexp against all asset values
            .filter(it => it === false) // don't care about success
            .length;
          if (searchFailures) return false;
        }

        return true;
      });

      this.maxPages = Math.ceil(this.dartOffersFiltered.length / (+this.pageSize));

      this.dartOffersDisplay = [
        ...(this.dartOffersFiltered.slice(start, end)),
      ];
    }
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.loadDartOffersToDisplay();
  }

  cancel(): void {
    this.result = null;
    this.close();
  }

  async save() {
    this.result = this.dartOffers.filter(offer => offer.selected);
    this.close();
  }

  offerSelected(dartOffer) {
    const selectedOfferIndex = this.dartOffers.findIndex(offer => offer.offerNumber === dartOffer.offerNumber);
    if (selectedOfferIndex >= 0 && selectedOfferIndex < this.dartOffers.length) {
      this.dartOffers[selectedOfferIndex].selected = dartOffer.selected;
    }
  }
}
